module.exports = __webpack_public_path__ + "static/media/Queens_jam.34ee0fca.png";